module.exports = __webpack_public_path__ + "img/logo_correos_express.03874919.png";